var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.929688,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0028 15.1753L19.0899 11.0866C19.2999 10.8774 19.6394 10.8774 19.8292 11.0866C20.057 11.2959 20.057 11.6354 19.8292 11.8447L15.7599 15.9325L19.8292 20.0196C20.057 20.2295 20.057 20.569 19.8292 20.7588C19.6394 20.9866 19.2999 20.9866 19.0899 20.7588L15.0028 16.6896L10.915 20.7588C10.7058 20.9866 10.3663 20.9866 10.157 20.7588C9.94767 20.569 9.94767 20.2295 10.157 20.0196L14.2457 15.9325L10.157 11.8447C9.94767 11.6354 9.94767 11.2959 10.157 11.0866C10.3663 10.8774 10.7058 10.8774 10.915 11.0866L15.0028 15.1753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.2198cb92450c85fd72fd08327a021458.svg";
export { ForwardRef as ReactComponent };